import { useState } from 'react';
import NamedEntityCrudSection from './NamedEntityCrudSection';
import MriConditionsSection from './MriConditionsSection';
import {
  getRadiologistBodySystemsList,
  getRadiologyOrgansList,
} from '../../../api/mriRadiology';
import './MriConditionsTab.scss';

type MriSubTab = 'conditions' | 'radiologist-body-systems' | 'organs';

const MRI_SUB_TABS: { id: MriSubTab; label: string }[] = [
  { id: 'conditions', label: 'MRI Conditions' },
  { id: 'radiologist-body-systems', label: 'Radiologist Body System' },
  { id: 'organs', label: 'Radiologist Organ' },
];

const MriConditionsTab = () => {
  const [activeSubTab, setActiveSubTab] = useState<MriSubTab>('conditions');

  return (
    <div className='mri-conditions-tab'>
      <div className='sub-tabs-container'>
        {MRI_SUB_TABS.map((tab) => (
          <button
            key={tab.id}
            type='button'
            className={`sub-tab ${activeSubTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveSubTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeSubTab === 'conditions' && <MriConditionsSection />}

      {activeSubTab === 'radiologist-body-systems' && (
        <NamedEntityCrudSection
          entityLabel='Radiologist Body System'
          entityLabelPlural='Radiologist Body Systems'
          readOnly
          fetchList={getRadiologistBodySystemsList}
        />
      )}

      {activeSubTab === 'organs' && (
        <NamedEntityCrudSection
          entityLabel='Radiologist Organ'
          entityLabelPlural='Radiologist Organs'
          readOnly
          fetchList={getRadiologyOrgansList}
        />
      )}
    </div>
  );
};

export default MriConditionsTab;
